import { NgModule } from "@angular/core";
import {
    AppIconWithOperatingSystemPipe,
    AppNamePipe,
    CamelCase,
    CanOperatingSystemAccessToResource,
    CatappultDateAndTimePipe,
    CatappultDatePipe,
    CatappultTimePipe,
    CountriesFilterPipe,
    CountryCodeFlagIconUrlPipe,
    CountryIconPipe,
    CountryNamePipe,
    CountryObjectPipe,
    CurrencySimbolPipe,
    DisplayTypePipe,
    FilesDownloadPipe,
    FilterPreGeneratedCSVListBySubType,
    GetLocaleDataFromMetadataPipe,
    GetLocaleDataFromVersionPipe,
    IconByUidPipe,
    IconType,
    IsApprovedPipe,
    IsCurrencyPipe,
    IsDebitPipe,
    IsPendingPipe,
    IsRejectedPipe,
    JoinArrayPrintPipe,
    LabelByUidPipe,
    NotificationIcon,
    PartnerDisplayNamePipe,
    ShowIfDateDiffGreaterThanDaysNumberPipe,
    ShowIfDateMonthAndYearAreDiff,
    ShowPackageInfoPipe,
    SkeletonArrayPipe,
    SubmissionFormCardInteractivityState,
    TitleOrPackageNameAppsListFilterPipe,
    ToLocaleStringPipe,
    TotalPipe,
    ValidDateFormat,
    isValidNumberPipe,
    showDashboardCardPipe,
    storeNameListPipe,
} from "./pipes";

@NgModule({
    declarations: [
        SkeletonArrayPipe,
        TotalPipe,
        ShowIfDateDiffGreaterThanDaysNumberPipe,
        ShowIfDateMonthAndYearAreDiff,
        IsCurrencyPipe,
        FilesDownloadPipe,
        TitleOrPackageNameAppsListFilterPipe,
        SubmissionFormCardInteractivityState,
        CatappultTimePipe,
        CatappultDatePipe,
        CatappultDateAndTimePipe,
        IsDebitPipe,
        IsApprovedPipe,
        IsPendingPipe,
        IsRejectedPipe,
        DisplayTypePipe,
        ShowPackageInfoPipe,
        ToLocaleStringPipe,
        CountryCodeFlagIconUrlPipe,
        CountryNamePipe,
        LabelByUidPipe,
        IconByUidPipe,
        CountryIconPipe,
        GetLocaleDataFromVersionPipe,
        CountryNamePipe,
        CountryIconPipe,
        AppNamePipe,
        storeNameListPipe,
        CamelCase,
        AppIconWithOperatingSystemPipe,
        CountryObjectPipe,
        isValidNumberPipe,
        CurrencySimbolPipe,
        ValidDateFormat,
        IconType,
        CountriesFilterPipe,
        PartnerDisplayNamePipe,
        JoinArrayPrintPipe,
        showDashboardCardPipe,
        CanOperatingSystemAccessToResource,
        GetLocaleDataFromMetadataPipe,
        FilterPreGeneratedCSVListBySubType,
        NotificationIcon,
    ],
    imports: [],
    exports: [
        SkeletonArrayPipe,
        TotalPipe,
        ShowIfDateDiffGreaterThanDaysNumberPipe,
        ShowIfDateMonthAndYearAreDiff,
        IsCurrencyPipe,
        FilesDownloadPipe,
        TitleOrPackageNameAppsListFilterPipe,
        SubmissionFormCardInteractivityState,
        CatappultTimePipe,
        CatappultDatePipe,
        CatappultDateAndTimePipe,
        IsDebitPipe,
        IsApprovedPipe,
        IsPendingPipe,
        IsRejectedPipe,
        DisplayTypePipe,
        ShowPackageInfoPipe,
        ToLocaleStringPipe,
        CountryCodeFlagIconUrlPipe,
        CountryNamePipe,
        LabelByUidPipe,
        IconByUidPipe,
        CountryIconPipe,
        GetLocaleDataFromVersionPipe,
        CountryNamePipe,
        CountryIconPipe,
        AppNamePipe,
        storeNameListPipe,
        CamelCase,
        AppIconWithOperatingSystemPipe,
        CountryObjectPipe,
        isValidNumberPipe,
        CurrencySimbolPipe,
        ValidDateFormat,
        IconType,
        CountriesFilterPipe,
        PartnerDisplayNamePipe,
        JoinArrayPrintPipe,
        showDashboardCardPipe,
        CanOperatingSystemAccessToResource,
        GetLocaleDataFromMetadataPipe,
        FilterPreGeneratedCSVListBySubType,
        NotificationIcon,
    ],
    providers: [
        TotalPipe,
        ShowIfDateDiffGreaterThanDaysNumberPipe,
        ShowIfDateMonthAndYearAreDiff,
        IsCurrencyPipe,
        FilesDownloadPipe,
        TitleOrPackageNameAppsListFilterPipe,
        SubmissionFormCardInteractivityState,
        CatappultTimePipe,
        CatappultDatePipe,
        CatappultDateAndTimePipe,
        IsDebitPipe,
        IsApprovedPipe,
        IsPendingPipe,
        IsRejectedPipe,
        DisplayTypePipe,
        ShowPackageInfoPipe,
        ToLocaleStringPipe,
        CountryCodeFlagIconUrlPipe,
        CountryNamePipe,
        LabelByUidPipe,
        IconByUidPipe,
        CountryIconPipe,
        GetLocaleDataFromVersionPipe,
        CountryNamePipe,
        CountryIconPipe,
        AppNamePipe,
        storeNameListPipe,
        CamelCase,
        AppIconWithOperatingSystemPipe,
        CountryObjectPipe,
        isValidNumberPipe,
        CurrencySimbolPipe,
        ValidDateFormat,
        IconType,
        CountriesFilterPipe,
        PartnerDisplayNamePipe,
        JoinArrayPrintPipe,
        showDashboardCardPipe,
        GetLocaleDataFromMetadataPipe,
        FilterPreGeneratedCSVListBySubType,
        NotificationIcon,
    ],
})
export class PipesModule {}
